import React from 'react';
import { cn } from '../../lib/utils';

export function Section({ id, children, className = '', ...rest }) {
  return (
    <section id={id} className={cn('py-16 md:py-24', className)} {...rest}>
      <div className="max-w-[1200px] mx-auto px-6">
        {children}
      </div>
    </section>
  );
}

export function SectionHeader({ title, subtitle, action, className = '' }) {
  return (
    <div className={cn('mb-8 flex flex-col md:flex-row md:items-end md:justify-between gap-4', className)}>
      <div>
        {title && <h2 className="t-h2 text-[var(--fg-primary)]">{title}</h2>}
        {subtitle && <p className="mt-2 text-sm text-[var(--fg-secondary)]">{subtitle}</p>}
      </div>
      {action && <div>{action}</div>}
    </div>
  );
}

export default Section;
